import Player from './player'
import * as Controls from './controls/*.js'
import Skin from './skin'
export default Player
